import React, { forwardRef } from 'react';
import { cx } from '../utils';
import './Card.css';

// padding: none | sm | md | lg
const Card = forwardRef(function Card(
  { title, subtitle, actions, padding = 'md', className, children, ...rest },
  ref
) {
  const hasHeader = Boolean(title || subtitle || actions);

  return (
    <div {...rest} ref={ref} className={cx('ui-card', `ui-card--pad-${padding}`, className)}>
      {hasHeader && (
        <div className="ui-card__header">
          <div className="ui-card__heading">
            {title && <h3 className="ui-card__title">{title}</h3>}
            {subtitle && <p className="ui-card__subtitle">{subtitle}</p>}
          </div>
          {actions && <div className="ui-card__actions">{actions}</div>}
        </div>
      )}
      {children}
    </div>
  );
});

export default Card;
